export default {
	limit: 5
}



// WEBPACK FOOTER //
// ./src/PostKitConfig.js